import moment from "moment";

import { updateUserLanguage } from "../users/settings";

import { logoutRequested, refreshToken, userLoggedOut, logoutProvider } from "../users/auth";

export const logoutUser =
  ({ dispatch, getState }) =>
  next =>
  action => {
    if (action.type === logoutRequested.type) {
      const authData = getState().users.auth.data;
      const ExternalLogin = authData ? authData.ExternalLogin : null;

      const idToken = authData ? (authData.ExternalIdToken || authData.externalIdToken) : null;

      dispatch(updateUserLanguage());
      dispatch({ type: userLoggedOut.type });

      if (ExternalLogin) {
          logoutProvider(idToken);

        // If we stop writing those to sessionstorage, we can remove those from here.
        sessionStorage.removeItem("ADToken");
        sessionStorage.removeItem("accessToken");
      }
    }

    return next(action);
  };

let lastDispatched;

export const refreshUserToken =
  ({ dispatch, getState }) =>
  next =>
  action => {
    const { tokenLastFetched } = getState().users.auth;

    const diffInMinutes = moment().diff(moment(tokenLastFetched), "minutes");
    const diffInDispatches = Date.now() - lastDispatched;

    if (
      tokenLastFetched &&      
      diffInMinutes >= (window._env_.REACT_APP_COMMON_REQUEST_INTERVAL || process.env.REACT_APP_COMMON_REQUEST_INTERVAL) &&
      diffInMinutes <= 30 &&
      (diffInDispatches > 10000 || !diffInDispatches)
    ) {
      lastDispatched = Date.now();
      dispatch(refreshToken());
    }

    next(action);
  };
